<script lang="ts">
  import Confetti from 'canvas-confetti';
  import { onMount } from 'svelte';
  import type { Match } from '~/types';
  import { d as starPath } from '~/icons/Star.svelte';
  import { theme } from '~/theme/darkMode.svelte';
  import { delay } from '~/animations/utils.svelte';
  import { sendWordAnimation } from '~/animations/crossfade.svelte';
  import { wordToString } from '~/board/utils';

  type Props = {
    word?: Pick<Match, 'word' | 'score'>;
  };
  const props: Props = $props();

  const key = $derived(props.word && wordToString(props.word));
  // svelte-ignore state_referenced_locally
  let prevKey = $state(key);

  let canvasRef: HTMLCanvasElement;
  let confetti: Confetti.CreateTypes;

  const multsLight = ['#DCF381', '#F28080', '#8282F2', '#AFDA8B'];
  const multsDark = ['#9A6818', '#9A181F', '#187498', '#00762D'];

  let innerWidth = $state<number>();
  let innerHeight = $state<number>();

  const common: Confetti.Options = {
    disableForReducedMotion: true,
    colors: theme.current === 'light' ? multsLight : multsDark,
    origin: { x: 0.5, y: 1 },
    startVelocity: 30,
    gravity: 0.6,
    spread: 90,
    ticks: 100,
  };

  onMount(() => {
    // 1. Multiply the canvas's width and height by the devicePixelRatio
    // const ratio = window.devicePixelRatio || 1
    // console.log(ratio);
    // canvasRef.width = innerWidth * ratio
    // canvasRef.height = innerHeight * ratio

    // // 2. Force it to display at the original (logical) size with CSS or style attributes
    // canvasRef.style.width = innerWidth + 'px'
    // canvasRef.style.height = innerHeight + 'px'

    // // 3. Scale the context so you can draw on it without considering the ratio.
    // const ctx = canvasRef.getContext('2d')
    // ctx?.scale(ratio, ratio)

    confetti = Confetti.create(canvasRef, {
      // useWorker: true,
      resize: true,
    });
  });

  const star = Confetti.shapeFromPath({
    path: starPath,
  });

  const triangle = Confetti.shapeFromPath({
    path: 'M48 0L0 48V6C0 2.68629 2.68629 0 6 0H48Z',
  });

  const THRESH = 24;

  $effect(() => {
    if (
      prevKey !== key &&
      confetti &&
      props.word &&
      props.word.score >= THRESH
    ) {
      prevKey = key;
      delay(1)
        .then(() => sendWordAnimation.settled())
        .then(() => {
          if (props.word!.word.find((t) => t.star)) {
            confetti({
              ...common,
              particleCount: 20 + Math.sqrt(props.word!.score),
              colors: ['#F9D923'],
              shapes: [star],
            });
          }
          delay(50).then(() =>
            confetti({
              ...common,
              particleCount: 10 + props.word!.score,
              shapes: ['square', triangle],
            }),
          );
        });
    }
  });
</script>

<svelte:window bind:innerWidth bind:innerHeight />
<canvas class="canvas" bind:this={canvasRef}></canvas>

<style>
  .canvas {
    inset: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1000;
  }
</style>
